import { composeIO } from 'react-compose-io'
import { controleCicloPedidoIO } from './ControleCicloPedido.IO'
import { ControleCicloPedidoView } from './ControleCicloPedido.View'

export const ControleCicloPedido = composeIO(ControleCicloPedidoView, controleCicloPedidoIO)
